import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getMultipleDrawItems } from '../../../../Store/MutipleDrawing/MultipleDrawing/MultipleDrawItems';
import Header from '../../Include/Header';
import Sidebar from '../../Include/Sidebar';
import Footer from '../../Include/Footer';
import moment from 'moment';

const ViewDrawing = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const data = location.state;
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [drawObj, setDrawObj] = useState({});

  useEffect(() => {
    if (data?._id) {
      setDrawObj(data);
      dispatch(getMultipleDrawItems({ id: data._id }));
    }
  }, [data]);
  const drawItems = useSelector((state) => state?.getMultipleDrawItems?.user?.data) || [];

  const formatDate = (date) => (date ? moment(date).format('YYYY-MM-DD') : '-');

  return (
    <div className={`main-wrapper ${isSidebarOpen ? 'slide-nav' : ''}`}>
      <Header handleOpen={() => setIsSidebarOpen(!isSidebarOpen)} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="page-header">
            <ul className="breadcrumb">
              <li className="breadcrumb-item"><Link to="/main-store/user/dashboard">Dashboard</Link></li>
              <li className="breadcrumb-item"><i className="feather-chevron-right" /></li>
              <li className="breadcrumb-item"><Link to="/main-store/user/drawing-management">Drawing List</Link></li>
              <li className="breadcrumb-item"><i className="feather-chevron-right" /></li>
              <li className="breadcrumb-item active">View Drawing</li>
            </ul>
          </div>

          <div className="card">
            <div className="card-body">
              <h4 className="mb-4">View Drawing Details</h4>
              <div className="row">
                {[
                  { label: 'Project Name', value: drawObj?.project?.name },
                  { label: 'Client Name', value: drawObj?.project?.party?.name },
                  { label: 'Firm Name', value: drawObj?.project?.firm_id?.name },
                  { label: 'Drawing Number', value: drawObj?.drawing_no },
                  { label: 'Revision', value: drawObj?.rev },
                  { label: 'Sheet Number', value: drawObj?.sheet_no },
                  { label: 'Unit', value: drawObj?.unit },
                  { label: 'Drawing Receive Date', value: formatDate(drawObj?.draw_receive_date) },
                  { label: 'PDF Name', value: drawObj?.drawing_pdf_name },
                ].map((field, idx) => (
                  <div className="col-md-4" key={idx}>
                    <div className="input-block local-top-form">
                      <label className="local-top">{field.label}</label>
                      <input className="form-control" value={field.value || '-'} readOnly />
                    </div>
                  </div>
                ))}
                <div className="col-md-4">
                  <div className="input-block local-top-form">
                    <a href={drawObj?.drawing_pdf} target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                      View PDF
                    </a>
                  </div>
                </div>
              </div>

              <div className="mt-4">
                <h5>Drawing Items</h5>
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Sr.</th>
                        <th>Item No</th>
                        <th>Grid No</th>
                        <th>Grid Qty</th>
                        <th>Item Qty</th>
                        <th>Length</th>
                        <th>Width</th>
                        <th>Radius</th>
                        <th>Thickness</th>
                        <th>Weight</th>
                        <th>Assembly Weight</th>
                        <th>Surface Area</th>
                      </tr>
                    </thead>
                    <tbody>
                      {drawItems.map((item, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{item.item_no}</td>
                          <td>{item.grid_id?.grid_no}</td>
                          <td>{item.grid_id?.grid_qty}</td>
                          <td>{item.item_qty}</td>
                          <td>{item.item_length || "-"}</td>
                          <td>{item.item_width || "-"}</td>
                          <td>{item.item_radius || "-"}</td>
                          <td>{item.item_thickness || "-"}</td>
                          <td>{item.item_weight || "-"}</td>
                          <td>{item.assembly_weight || "-"}</td>
                          <td>{item.assembly_surface_area || "-"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="col-12 text-end">
                <div className="doctor-submit text-end">
                  <button type="button"
                    className="btn btn-primary submit-form me-2" onClick={() => navigate("/main-store/user/drawing-management")}>Back</button>
                </div>
              </div>
            </div>
          </div>

        </div>
        <Footer />
      </div>
    </div>
  )
}

export default ViewDrawing